var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.params.show),expression:"params.show"}],staticClass:"cursor-pointer",attrs:{"src":require("../../../../assets/edit_pencil.svg"),"alt":""},on:{"click":_vm.onIconClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }